export const appConfig = {
    apiUrl: "https://parisdisneyshuttle.com/API/Postback.php",
    bIsCalender : false
}